var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Book_4001628",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.053,
    height: 76.062,
    viewBox: "0 0 76.053 76.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-books-study-education-school-book_store",
    "data-name": "book-books-study-education-school-book store",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41902",
    "data-name": "Path 41902",
    d: "M76.794,64.117a1.277,1.277,0,0,0,1.277-1.277V59.046a1.277,1.277,0,0,0-1.277-1.277H74.265V10.875A1.277,1.277,0,0,0,72.988,9.6H59.045V3.277A1.277,1.277,0,0,0,57.768,2H40.034a1.277,1.277,0,0,0-1.277,1.277V8.338h-11.4V7.061a1.277,1.277,0,0,0-1.277-1.277h-15.2A1.277,1.277,0,0,0,9.6,7.061V58.108a10.142,10.142,0,0,0,2.534,19.954H76.794a1.277,1.277,0,0,0,1.277-1.277V72.991a1.277,1.277,0,0,0-1.277-1.277H75.517v-7.6ZM59.045,12.142H71.711v7.6H59.045Zm0,10.142H71.711v3.8H59.045Zm0,6.338H71.711V57.779H59.045ZM41.3,4.534H56.511v8.875H41.3Zm0,11.409H56.511V57.779H53.977V23.548A1.277,1.277,0,0,0,52.7,22.27H45.1a1.277,1.277,0,0,0-1.277,1.277V57.779H41.291ZM51.44,24.817V57.771H46.37V24.817ZM27.353,10.875h11.4v7.6h-11.4Zm0,10.142h11.4V57.779h-11.4ZM12.141,8.338H24.817v8.875H12.141Zm0,11.409H24.817v5.071H12.141Zm0,7.6H24.817V57.776H12.141Zm2.534,34.231a6.338,6.338,0,1,0,0,12.676h60.85v1.277H12.141a7.606,7.606,0,1,1,0-15.212H75.525V61.6Zm58.313,2.534v7.6H70.454v-7.6ZM67.92,69.185v2.534H14.678a3.8,3.8,0,1,1,0-7.6H67.92v2.534H17.212v2.537Z",
    transform: "translate(-2.018 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6379",
    "data-name": "Rectangle 6379",
    width: 7.748,
    height: 2.818,
    transform: "translate(12.659 28.874)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6380",
    "data-name": "Rectangle 6380",
    width: 7.748,
    height: 2.113,
    transform: "translate(12.659 34.51)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookIcon);
export default __webpack_public_path__ + "static/media/notebook-icon.757a0b60a3a225df9532f65bcb3c8976.svg";
export { ForwardRef as ReactComponent };